<template>
    <popup :opened="dataToShow" @close="close" width="lg:w-11/12 sm:w-full">

        <!-- BEGIN Content modal add referent -->
        <div
class="transform origin-top-left"
                :class="{
                    'scale-40 md:scale-75 lg:scale-100 mt-15 md:mt-0 md:ml-1/10 lg:ml-0': isPortraitOrientation,
                    'scale-30 md:scale-35 lg:scale-75 mt-15 md:mt-0 -ml-4  md:ml-1/4 lg:ml-0': !isPortraitOrientation
                }"
        >
            <div class="my-5 mx-5 lg:my-15 lg:mx-10 2xl:my-20 2xl:mx-15">
                <vue-html2pdf
                    class="bg-white w-max border-2 border-gray-600"
                    :show-layout="false"
                    :float-layout="false"
                    :enable-download="true"
                    :preview-modal="false"
                    filename="cv.pdf"
                    :pdf-quality="2"
                    :manual-pagination="true"
                    pdf-format="a4"
                    :pdf-content-width="!isPortraitOrientation ? '1122px' : '800px'"
                    :html-to-pdf-options="{
                        enableLinks: true,
                        filename: 'CV ',
                        jsPDF: {
                            orientation: isPortraitOrientation ? 'portrait' : 'landscape',
                            format: 'a4'
                        },
                        html2canvas: {scale: 2}
                    }"
                    @progress="onProgress($event)"
                    @hasStartedGeneration="hasStartedGeneration()"
                    @hasGenerated="hasGenerated($event)"
                    ref="cvPdf"
                >
                    <section slot="pdf-content">
                        <section class="pdf-item">
                            <model-pdf :model-name="(((cvToPreview || {}).data || {}).shaping || {}).name" :model-color="(((cvToPreview || {}).data || {}).shaping || {}).color" :form="cvToPreview"/>
                        </section>
                    </section>
                </vue-html2pdf>
            </div>
        </div>
        <!-- END Content modal add referent -->
    </popup>
</template>

<script>
import Popup from './../../../components/Popup';
import Icon from './../../../components/Icon.vue';
import VueHtml2pdf from 'vue-html2pdf';
import ModelPdf from './../pdf/ModelPdf.vue';
import Constants from './../../../constants';
import { mapGetters } from 'vuex';

export default {
  name:'PreviewCvPopup',

  components:{
    Popup,
    Icon,
    VueHtml2pdf,
    ModelPdf
  },

  props:{
    dataToShow: Boolean,
    cvToPreview:Object,
  },

  data() {
    return {
      constants: Constants
    };
  },

  computed:{
    ...mapGetters({
      form: 'curriculumVitae/form',
    }),

    isPortraitOrientation(){
      switch (this.form.type) {
      case Constants.CV_TYPES.BASIC:
        return true;
                
      case Constants.CV_TYPES.DASHBOARD:
        return false;
            
      default:
        return true;
      }
    }
  },

  methods:{
        
    close(){
      this.$emit('close');
    },
  }
};
</script>
